









import BaseContentsVue from './BaseContents.vue'
import XContainer from '@/components/atoms/Container/XContainer.vue'
import FfpAgentOrder from '@/components/molecules/FfpAgent/FfpAgentOrder.vue'

export default BaseContentsVue.extend({
  name: 'FfpAgentSales',
  components: { XContainer, FfpAgentOrder },
})
